module.exports = __webpack_public_path__ + "static/banner-5star-c7f3d8ca92baa615df093f4c86e65ad0.png";